import { useMemo } from 'react';
import { Table, useOnScrollDownWithoutTotal } from 'redesign';
import { useSiteDetection } from 'shared/hooks';
import { RenderUnsettledUI } from 'shared/components';
import { useGetWorkflowListing } from 'ogp/hooks/queryHooks/workflows/use-get-workflow-listing';
import { Typography } from '@mui/material';
import { WorkflowsColumnDefinition, WorkflowsTableOptions } from './workflows.types';
import { getWorkflowColumnDefinition } from './workflows-column-definition';
import { useGetWorkflowMenuActions } from './hooks/use-get-workflow-menu-actions';
import { WorkflowTableProps } from './workflow-table.types';
import { parseTableData } from './utils/parse-table-data';

export const WorkflowsTableDataProvider = () => {
  const { site } = useSiteDetection();
  const infiniteQueryResult = useGetWorkflowListing(site);

  if (infiniteQueryResult.status !== 'success') {
    return <RenderUnsettledUI data={infiniteQueryResult} />;
  }
  return <WorkflowsTable infiniteQueryResult={infiniteQueryResult} />;
};

const WorkflowsTable = (props: WorkflowTableProps) => {
  const { infiniteQueryResult } = props;
  const flatData = useMemo(
    () => infiniteQueryResult.data.pages.flatMap((page) => page.items),
    [infiniteQueryResult.data]
  );
  const { fetchIfBottomScrolled } = useOnScrollDownWithoutTotal({
    infiniteQueryResult: infiniteQueryResult,
  });

  const { getMenuActions } = useGetWorkflowMenuActions();

  const columns = useMemo(() => getWorkflowColumnDefinition(), []);
  const tableData = useMemo(() => parseTableData(flatData), [flatData]);

  return (
    <>
      {tableData.length === 0 ? (
        <Typography>Er zijn geen workflows.</Typography>
      ) : (
        <Table<WorkflowsColumnDefinition, WorkflowsTableOptions>
          stickyHeader={true}
          columns={columns}
          data={tableData}
          getRowActions={getMenuActions}
          tableStyle={{ tableLayout: 'fixed' }}
          onScroll={fetchIfBottomScrolled}
          isRowDisabled={(row) => row.isArchived}
        ></Table>
      )}
    </>
  );
};
